import buildUrl from './buildUrl';
import extractUser from './extractUser';
import { isTwitterOrXUrlLike } from './isTwitterOrXUrlLike';

/**
 * Normalizes a Twitter/X handle or profile URL to https://x.com/{handle} (no `www.`).
 * Accepts twitter.com or x.com URLs, with or without protocol, or a plain handle.
 */
const normalizeTwitterOrXToUrl = (value: string): string => {
  const v = value.trim();
  if (!v) return '';

  const withoutAt = v.replace(/^@/, '');

  if (isTwitterOrXUrlLike(v)) {
    const user = extractUser(v);
    if (user) return buildUrl(user, 'x');
  }

  if (/twitter\.com|x\.com/i.test(v)) {
    const prefixed = /^https?:/i.test(v) ? v : `https://${v.replace(/^\/\//, '')}`;
    const user = extractUser(prefixed);
    if (user) return buildUrl(user, 'x');
  }

  return buildUrl(withoutAt, 'x');
};

export default normalizeTwitterOrXToUrl;
